import { API_PREFIX } from '@/config/api'
import router from '@/router'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { api } from '@rfc/rfc-components-library/helpers'
import { ADMIN_ROUTE } from '@rfc/rfc-components-library/router'
import type { FilterType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'

const API_EVENT_PREFIX = `${API_PREFIX}${ADMIN_ROUTE}/statistics`

const adminApi = {
    getStats: (
        params?: Partial<PaginationType> & Partial<FilterType<Partial<CheckpointModel>>>,
        noQueryParam?: boolean
    ) =>
        api
            .get(`${API_EVENT_PREFIX}${buildQueryUrl(params, noQueryParam, router)}`)
            .then(res => res.data)
}

export default adminApi
